/**
 * @prettier
 * @flow
 */
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import type { PaymentLinkVm } from 'src/types/PaymentLinkVm';
import { translate } from 'src/utils/translate/translate';

export function PaymentNotAvailable({ paymentLink }: Props) {
    const classes = useStyles();
    return (
        <Grid container direction='row' justify='center' alignItems='center' className={classes.container}>
            <div className={classes.paper}>
                <Typography variant='h4' align='center' color='textSecondary'>
                    {translate('Payment link is no longer available')}
                </Typography>
                <Typography variant='subtitle1' align='center' className={classes.header} color='textSecondary'>
                    {translate('Please contact @company to receive a new payment link', { company: paymentLink?.companyName })}
                </Typography>
            </div>
        </Grid>
    );
}

const useStyles = makeStyles(theme => ({
    container: {
        height: '100%',
    },
}));

type Props = {
    paymentLink?: PaymentLinkVm,
};
